import { refreshUserById } from "@/api/auth/actions";

export type AvatarUserLike = {
  id?: string | number;
  avatar?: string | null;
  profile_pic?: string | null;
  [key: string]: any;
};

export const normalizeAvatarFields = <T extends AvatarUserLike>(
  user: T,
  source?: Partial<AvatarUserLike> | null
): T => {
  const avatar = user.avatar ?? user.profile_pic ?? source?.avatar ?? source?.profile_pic ?? null;
  const profilePic = user.profile_pic ?? user.avatar ?? source?.profile_pic ?? source?.avatar ?? null;

  return {
    ...user,
    ...(avatar ? { avatar } : {}),
    ...(profilePic ? { profile_pic: profilePic } : {})
  };
};

export const hydrateAvatarFields = async <T extends AvatarUserLike>(user: T): Promise<T> => {
  const normalized = normalizeAvatarFields(user);

  if (normalized.avatar || normalized.profile_pic) {
    return normalized;
  }

  // Pending accounts do not have a Sellpath user profile row yet.
  if (normalized.pendingWorkspaceSelection || normalized.spPendingWorkspaceSelection) {
    return normalized;
  }

  if (!normalized.id) {
    return normalized;
  }

  try {
    // Avatar hydration is best-effort. If the profile lookup is briefly unauthorized
    // during OAuth callback bootstrap, do not trigger a session refresh/logout loop.
    const response: any = await refreshUserById(normalized.id, undefined, { suppressAuthLogoutOn401: true });
    return normalizeAvatarFields(normalized, response?.content);
  } catch {
    return normalized;
  }
};
